import { inViewFade, inViewFadeUp } from '@helpers/animate';
import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import { baseGrid } from '@helpers/grid';
import { imageCoverContainer } from '@helpers/image';
import { Device, from } from '@helpers/media';
import { contentStyles, h3 } from '@helpers/typography';
import SectionWrapper from '@stories/Components/SectionWrapper/SectionWrapper';
import SimpleImage from '@stories/Components/SimpleImage/SimpleImage';
import styled from 'styled-components';
const Container = styled(SectionWrapper) `
  --fgColor: ${brand.white};

  position: relative;
  color: var(--fgColor);
  padding: var(--sectionSpacing) 0;
`;
const Inner = styled.div `
  ${baseGrid}
`;
const ImageWrapper = styled.div `
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  height: 100%;
  width: 100%;
  z-index: 1;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    background: rgba(0, 0, 0, var(--tintAmount));
    width: 100%;
  }

  ${inViewFade({ delay: 0, duration: 0.6 })};
`;
const Image = styled(SimpleImage) `
  ${imageCoverContainer(true)}
`;
const ContentWrapper = styled.div `
  position: relative;
  grid-column: 1 / span 12;
  max-width: 492px;
  z-index: 2;

  @media ${from(Device.TabletLarge)} {
    grid-column: 2 / span 10;
  }
`;
const Title = styled.div `
  ${h3};
  margin-bottom: 56px;

  ${inViewFadeUp({ delay: 0, duration: 0.3 })};
`;
const Content = styled.div `
  ${contentStyles};
  ${fonts.helvetica.bold};
  margin-bottom: 25px;

  ${inViewFadeUp({ delay: 0.15, duration: 0.3 })};
`;
const CtaWrapper = styled.div `
  ${inViewFadeUp({ delay: 0.3, duration: 0.3 })};
`;
const CtaSectionStyles = {
    Container,
    Content,
    ContentWrapper,
    CtaWrapper,
    Image,
    ImageWrapper,
    Inner,
    Title,
};
export default CtaSectionStyles;
